import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import {Block, Button, Space, Typography} from "@bezlimit/bezlimit-ui";
import {observer} from "mobx-react";
import _ from "lodash";
// core
import {LayoutContext, ModalContext} from "../../../../core/Contexts";
//store
import Store from "../../../../stores";
import "./style.scss";
import ModalVerification from "./modalVerification";

export const NewRegisterPassport: React.FC = observer(() => {
    const {t} = useTranslation();
    const contextLayout = useContext(LayoutContext);
    const contextModal = useContext(ModalContext);

    const onClick = () => {
        contextModal?.setMaskStyle({
            background: "rgba(0, 0, 0, 0.65)",
            // @ts-ignore
            "-webkit-backdrop-filter": " blur(31px)",
            "backdrop-filter": " blur(31px)"
        });
        contextModal?.setCssClass(" bl-modal-verification");
        contextModal?.setChildren(<ModalVerification />);
        contextModal?.setVisible(true);
    };

    return (
        <Block className="bl-new-register-passport">
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 40 : 24}
                direction="vertical"
                align="start"
            >
                <Typography as="div">
                    <Space size={8} direction="vertical" align="start">
                        <Typography
                            size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 17}
                            level={2}
                            color="#ffffff"
                        >
                            {t("Внесите паспортные данные")}
                        </Typography>
                        <Typography className="subtitle">
                            {_.gte(contextLayout?.width ?? 0, 768)
                                ? "Для законной работы с Безлимит и доступа ко всем возможностям приложения нужно пройти верификацию. \nЭто включает загрузку паспортных данных и подтверждение личности."
                                : "Для законной работы с Безлимит и доступа \nко всем возможностям приложения нужно \nпройти верификацию. Это включает загрузку \nпаспортных данных и подтверждение \nличности."}
                        </Typography>
                        <Button type="primary" onClick={onClick}>
                            {_.isEqual(Store.user?.verification?.status, "new")
                                ? " Начать верификацию"
                                : "Завершить верификацию"}
                        </Button>
                    </Space>
                </Typography>
            </Space>
        </Block>
    );
});
